export default {
    setVoucher(state, voucher) {
        state.voucher = voucher
    },
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/mutations/vouchersMutations.js